<script setup lang="ts">
defineProps<{
  title: string
  description: string
  icon: string
}>()

const {element, handleMove, handleOut} = useFloatingCard()
</script>

<template>
  <div
    ref="element"
    @mousemove="handleMove"
    @mouseout="handleOut"
    :class="['rounded-lg p-2 xs:p-4 sm:p-8', 'flex flex-col items-center', 'hover:bg-white hover:bordershadow-lg-gray']"
    :style="{transition: 'box-shadow 0.1s, transform 0.1s, background 0.1s'}"
  >
    <img :src="icon" aria-disabled role="presentation" class="mb-4 w-12 sm:mb-10 sm:w-16" />

    <Heading class="mb-4 w-fit rounded-full bg-main-100 px-4 py-1 text-center text-sm text-main-900 bordershadow-main">
      {{ title }}
    </Heading>
    <Paragraph class="text-gray- text-center text-[18px]">
      {{ description }}
    </Paragraph>
  </div>
</template>
